import React from 'react';

export const formatText = (text) => {
    var regExpSplit = /\$\(([^)]+)\)/g;
    var regExpWords = /[^(]+(?=\))/g;
    var words = text.match(new RegExp(regExpWords, 'gi'));
    let parts = text.split(new RegExp(regExpSplit, 'gi'));

    if (words === null)
        return <span>{text}</span>;

    return <span> {parts.map((part, i) =>
        <span key={i} style={words.indexOf(part) >= 0 ? { fontWeight: 'bold' } : {}}>
            {part}
        </span>)
    } </span>;
}



// WEBPACK FOOTER //
// ./src/areas/shared/components/audit/AuditFormat.js